import React from 'react';
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import { DEFAULT_TOAST_OPTIONS } from '@cokitchen/cokitchen-components';
import ALL_ROUTES from './router';
import RoleLayout from './layouts/role.layout';
import { MAIN_STORE_ROUTE_KEYS, ROUTE_KEYS } from './utils/constants';
import UnauthRoute from './router/UnauthRoute';
import Login from './pages/auth/login';
import ResetPassword from 'pages/auth/reset-password';
import VerifyEmail from 'pages/verify-email';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.Fragment>
    <ToastContainer {...DEFAULT_TOAST_OPTIONS} />
    <RoleLayout>
      <RouterProvider
        router={createBrowserRouter([
          {
            path: ROUTE_KEYS.LOGIN,
            element: (
              <UnauthRoute>
                <Login />
              </UnauthRoute>
            )
          },
          {
            path: ROUTE_KEYS.RESET_PASSWORD,
            element: <ResetPassword />
          },
          {
            path: '*',
            element: <Navigate to={ROUTE_KEYS.LOGIN} />
          },
          {
            path: MAIN_STORE_ROUTE_KEYS.VERIFY_EMAIL,
            element: <VerifyEmail />
          },
          ...ALL_ROUTES
        ])}
      />
    </RoleLayout>
  </React.Fragment>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
